module.exports = __webpack_public_path__ + "img/coming_soon.0af5d850.png";